import React from 'react';
import { gql } from '@apollo/client';
import BannerDesign2 from './BannerDesign2';
import BannerCarousel2 from './BannerCarousel2';
import ImagePlaceholder from '../../Image/ImagePlaceholder';
import { useQuery } from '@apollo/client/react';

const GET_BANNER = gql`
  query Banners($slot: String) {
    banners(slot: $slot) {
      slug
      bannerType
      image {
        urls {
          W435
          W540
          W890
          W1600
        }
      }
      buttons {
        buttonType
        title
        url
        buttonGroup
        brand {
          logoUrl
        }
      }
      title
      content
      hasDarkText
    }
  }
`;

export type Banner = {
  slug: string;
  bannerType: string;
  buttons: {
    buttonType: string;
    title: string;
    url: string;
    buttonGroup: string;
    brand: {
      logoUrl: string;
    };
  }[];
  image: {
    urls: {
      W435: string;
      W540: string;
      W890: string;
      W1600: string;
    };
  };
  title: string;
  content: string;
  hasDarkText: boolean;
};

type Props = {
  slot: string;
};

export default function SingleBanner2({ slot }: Props) {
  const { data, loading, error } = useQuery<{ banners: [Banner] }>(GET_BANNER, {
    variables: { slot },
  });

  const banners = data?.banners;

  if (loading || error || !banners?.length) {
    return (
      <ImagePlaceholder className="bg-rgrey-lightlight object-cover h-95 md:h-145 xl:h-180 w-full object-[75%_center] lg:object-[60%_center] xl:object-center" />
    );
  }

  if (banners.length > 1) {
    return <BannerCarousel2 banners={banners} />;
  }

  return <BannerDesign2 banner={banners[0]} />;
}
